import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    fbq: any;
  }
}

export const useFacebookPixel = () => {
  const location = useLocation();
  const initialized = useRef(false);

  useEffect(() => {
    // Only track pageview if not already initialized
    if (window.fbq && !initialized.current) {
      initialized.current = true;
      window.fbq('track', 'PageView');
    }
  }, []);

  // Track subsequent page views
  useEffect(() => {
    if (window.fbq && initialized.current) {
      window.fbq('track', 'PageView');
    }
  }, [location]);

  const trackEvent = (eventName: string, options = {}) => {
    if (window.fbq) {
      window.fbq('track', eventName, options);
    }
  };

  return { trackEvent };
};